"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticationSelector = exports.azureTokenSelector = exports.configSelector = void 0;

var _package = require("../../package.json");

var configSelector = function configSelector(state) {
  var _state$config, _state$config2, _state$config2$data, _state$config3, _state$config3$data;

  if (!((_state$config = state.config) !== null && _state$config !== void 0 && _state$config.data)) return;
  var instanceID = Object.keys((_state$config2 = state.config) === null || _state$config2 === void 0 ? void 0 : (_state$config2$data = _state$config2.data) === null || _state$config2$data === void 0 ? void 0 : _state$config2$data.widgets[_package.name])[0];
  return (_state$config3 = state.config) === null || _state$config3 === void 0 ? void 0 : (_state$config3$data = _state$config3.data) === null || _state$config3$data === void 0 ? void 0 : _state$config3$data.widgets[_package.name][instanceID];
};

exports.configSelector = configSelector;

var azureTokenSelector = function azureTokenSelector(store) {
  return store.authentication.access_token;
};

exports.azureTokenSelector = azureTokenSelector;

var authenticationSelector = function authenticationSelector(store) {
  return store.authentication;
};

exports.authenticationSelector = authenticationSelector;